import React from 'react';
import PropTypes from 'prop-types';

import { getDisplayUserName } from 'features/productQuestionsAndAnswers/utility';
import { getFormatDateWithDaysAgo } from 'utilities/date';

import './ProductReviewCardResponse.scss';

const ProductReviewCardResponse = ({ response }) => {

	const { text, user, dateCreated } = response;

	return (
		<div className="ProductReviewCardResponse">
			<div className="ProductReviewCardResponse__header">
				<div className="ProductReviewCardResponse__title">Response from Lamps Plus</div>
			</div>
			<div className="ProductReviewCardResponse__body">
				{text}
			</div>
			<div className="ProductReviewCardResponse__reviewerName">
				{getDisplayUserName(user)}
				{user.badge !== null && (
					<span className="ProductReviewCardResponse__badge">
						{user.badge.text}
					</span>
				)}
			</div>
			{dateCreated !== null && (
				<div className="ProductReviewCardResponse__dateCreated">
					{getFormatDateWithDaysAgo(dateCreated)}
				</div>
			)}
		</div>
	);

};

ProductReviewCardResponse.propTypes = {
	response: PropTypes.shape({
		text: PropTypes.string.isRequired,
		dateCreated: PropTypes.string.isRequired,
		user: PropTypes.shape({
			firstName: PropTypes.string.isRequired,
			lastName: PropTypes.string.isRequired,
			nickName: PropTypes.string,
			badge: PropTypes.shape({
				text: PropTypes.string
			})
		})
	})
};
export default ProductReviewCardResponse;
